import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TruckJourneyDeliveryEdit, TruckJourneyLoadEdit } from '../../models/truck-journey.model';
import { Markers } from '../../../../shared/markers';
import { ToastrService } from 'ngx-toastr';
import { noop } from 'rxjs';

@Component({
  selector: 'app-truck-journey-edit-load',
  templateUrl: './truck-journey-edit-load.component.html',
  styleUrls: ['./truck-journey-edit-load.component.scss']
})
export class TruckJourneyEditLoadComponent implements OnChanges {

  @Input() truckJourneyLoad: TruckJourneyLoadEdit
  @Output() truckJourneyLoadChange: EventEmitter<TruckJourneyLoadEdit> = new EventEmitter<TruckJourneyLoadEdit>();
  @Output() onEditStop: EventEmitter<void> = new EventEmitter<void>();
  @Output() isEditingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public reorderedDeliveries: TruckJourneyDeliveryEdit[];
  private _isEditing = false;

  public chepDepartureIconUrl = Markers.DEPARTURE_LOAD.chep
  public customerDepartureIconUrl = Markers.DEPARTURE_LOAD.customer;

  protected readonly noop = noop;

  get isEditing(): boolean {
    return this._isEditing;
  }

  set isEditing(value: boolean) {
    if (value !== this._isEditing) {
      this.isEditingChange.emit(value);
    }
    this._isEditing = value;
  }

  constructor(private toastrService: ToastrService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.reorderedDeliveries = this.truckJourneyLoad.deliveries.slice();
  }

  moveDeliveryToNewPosition(currentDeliveryIndex: number, newDeliveryIndex: number) {
    this.isEditing = true;
    const deliveryToMove = this.reorderedDeliveries.splice(currentDeliveryIndex, 1)[0];
    if (deliveryToMove) {
      this.reorderedDeliveries.splice(newDeliveryIndex, 0, deliveryToMove);
    } else {
      this.toastrService.error(`Error while moving element from position ${currentDeliveryIndex + 1} to ${newDeliveryIndex + 1}`)
    }
  }

  cancelEdition() {
    this.reorderedDeliveries = this.truckJourneyLoad.deliveries.slice();
    this.isEditing = false;
    this.onEditStop.emit();
  }

  confirmEdition() {
    this.truckJourneyLoad.deliveries = this.reorderedDeliveries.slice();
    this.truckJourneyLoadChange.emit(this.truckJourneyLoad);
    this.isEditing = false;
    this.onEditStop.emit();
  }
}
